module.exports = __webpack_public_path__ + "img/p5.3e539bb8.png";